import { create } from "zustand";

// ドラッグ / リサイズ中の「ライブ枠」を保持する一時 store。
//
// オブジェクトのドラッグ・リサイズは DOM の left/top/width/height を直接書き換えてプレビューし、
// pointerup まで doc store には反映しない（高頻度な store 更新を避けるため）。
// 一方でコネクタ（接続矢印）は接続先オブジェクトの現在位置から都度ルーティングして描画するため、
// ドラッグ中も追従させるには「確定前の枠」を知る必要がある。
//
// そこで本 store に、操作中オブジェクトの確定前フレームを objectId 単位で保持する。
// コネクタコンポーネントは自分の端点 id のフレームだけを selector で購読するため、
// 無関係なオブジェクトのドラッグでは再描画されない（frames[id] が undefined のままで参照同一）。

export interface LiveFrame {
  readonly x: number;
  readonly y: number;
  readonly w: number;
  readonly h: number;
}

interface ConnectorDragState {
  /** 操作中オブジェクトの確定前フレーム（ステージ座標）。 */
  readonly frames: Record<string, LiveFrame>;
  /** 複数オブジェクトのライブ枠をまとめて設定（既存分へマージ）する。 */
  readonly setFrames: (updates: Record<string, LiveFrame>) => void;
  /** 指定 id のライブ枠を取り除く（pointerup での確定後に呼ぶ）。 */
  readonly clearFrames: (ids: readonly string[]) => void;
}

export const useConnectorDragStore = create<ConnectorDragState>((set) => ({
  frames: {},
  setFrames: (updates) =>
    set((state) => ({ frames: { ...state.frames, ...updates } })),
  clearFrames: (ids) =>
    set((state) => {
      if (ids.length === 0) return state;
      let changed = false;
      const next = { ...state.frames };
      for (const id of ids) {
        if (id in next) {
          delete next[id];
          changed = true;
        }
      }
      return changed ? { frames: next } : state;
    }),
}));
